import React, { useState, useEffect, useRef } from "react";

import ReactDOM from "react-dom";
import PropTypes from "prop-types";
import cx from "classnames";
import Popup from "reactjs-popup";
// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";
import AppBar from "@material-ui/core/AppBar";
import Toolbar from "@material-ui/core/Toolbar";
import Hidden from "@material-ui/core/Hidden";

// material-ui icons
import Menu from "@material-ui/icons/Menu";

// core components
import Button from "common/components/CustomButtons/Button.jsx";

import adminNavbarStyle from "assets/jss/material-dashboard-pro-react/components/adminNavbarStyle.jsx";

/*
 */

function AdminNavbar({ ...props }) {
  const { classes, color, brandText } = props;
  const [tooltipOpen, setTooltipOpen] = useState(false);
  const [tooltipStyle, setTooltipStyle] = useState({
    position: "absolute",
    top: 0,
    left: 0
  });
  const hamburgerEl = useRef(null);

  useEffect(() => {
    try {
      if (window.localStorage.getItem("hamburgerTooltip") == null) {
        setTooltipOpen(true);
      }
    } catch (e) {
      console.log(e.message);
    }
    const domrect = ReactDOM.findDOMNode(
      hamburgerEl.current
    ).getBoundingClientRect();
    setTooltipStyle({
      position: "absolute",
      top: domrect.top,
      left: domrect.left + domrect.width
    });
  }, []);

  const appBarClasses = cx({
    [" " + classes[color]]: color
  });
  return (
    <AppBar className={classes.appBar + appBarClasses}>
      <Toolbar className={classes.container}>
        <div className={classes.flex}>
          <Hidden mdUp implementation="css">
            <Button
              color="transparent"
              aria-label="open drawer"
              onClick={props.handleDrawerToggle}
            >
              <Menu
                style={{ width: "29px", height: "29px" }}
                className={classes.hamburgerIcon}
                ref={hamburgerEl}
              />
            </Button>
            <Popup
              trigger={open => <span style={tooltipStyle} />}
              position="right center"
              closeOnDocumentClick
              open={tooltipOpen}
            >
              <div className={classes.tooltipDiv}>
                <span className={classes.tooltip}>
                  Click here to open the Menu
                </span>
                <Button
                  color="primaryRed"
                  aria-label="open drawer"
                  onClick={() => {
                    setTooltipOpen(false);
                    try {
                      window.localStorage.setItem("hamburgerTooltip", true);
                    } catch (e) {
                      console.log(e.message);
                    }
                  }}
                >
                  GOT IT
                </Button>
              </div>
            </Popup>

            <Button href="#" className={classes.title} color="transparent">
              {brandText}
            </Button>
          </Hidden>
          <Hidden smDown implementation="css">
            <div className={classes.flexWrapper}>
              <Button href="#" className={classes.title} color="transparent">
                {brandText}
              </Button>
              <div>Logged as {props.userEmail}</div>
            </div>
          </Hidden>
          {/* Here we create navbar brand, based on route name */}
        </div>
      </Toolbar>
    </AppBar>
  );
}

AdminNavbar.propTypes = {
  classes: PropTypes.object.isRequired,
  color: PropTypes.oneOf(["primary", "info", "success", "warning", "danger"]),
  rtlActive: PropTypes.bool,
  brandText: PropTypes.string
};

export default withStyles(adminNavbarStyle)(AdminNavbar);
